import React from 'react';

function ProblemSolution() {
  return (
    <section className="problem-solution-section">
      <div className="container">
        <h2>Still looking for high quality, locally grown food at a fair price?</h2>
        <div className="problem-grid">
          <div className="problem-item">
          <img src="/images/food-quality.png" alt="Foood quality problem illustration" className="problem-image"/>
            <h3>Food Quality Concerns</h3>
            <p>Growing impact of pesticides, GMOs, and the loss of nutritional value of mass-produced food, with some studies showing nutritional losses of up to 30% within a few days of harvesting.</p>
          </div>
          <div className="problem-item">
          <img src="/images/food-waste.png" alt="Foood waste problem illustration" className="problem-image"/>
            <h3>Massive Food Waste</h3>
            <p>A significant amount of food is wasted due to centralized agriculture practices, with about 30% of food in American grocery stores being thrown away.</p>
          </div>
          <div className="problem-item">
          <img src="/images/food-desert.png" alt="Foood access problem illustration" className="problem-image"/>
            <h3>Limited Access</h3>
            <p>According to the USDA, 53.6 million people in the United States live in food deserts, areas with limited access to fresh, healthy food.</p>
          </div>
        </div>

        <div className="solution-box">
          <h3>Homesteadr is the Solution</h3>
          <p>Homesteadr makes it easy to grow your own food and connect with your community. Using the power of AI, Homesteadr helps you eat healthier, live more sustainably, and foster local connections.</p>
        </div>
      </div>
    </section>
  );
}

export default ProblemSolution;
